import moment from 'moment'

import ParamsGrid from 'components/attacks/create/ParamsGrid'
import TriggerField from 'components/attacks/create/trigger/TriggerField'

function RandomTrigger() {
  return (
    <ParamsGrid>
      <TriggerField
        data-test-random-executions-input
        rightAligned
        description="The number of times run per run-window"
        fieldName="maxRuns"
        min={1}
        placeholder="#"
        title="Runs per day"
        type="number"
      />
      <TriggerField
        data-test-random-from-input
        masked
        required
        description="Local time, 24-hour format"
        fieldName="start"
        mask="11:11"
        placeholder={moment().add(1, 'hour').startOf('hour').format('HH:mm')}
        title="Start of run-window"
      />
      <TriggerField
        data-test-random-to-input
        masked
        required
        description="Local time, 24-hour format"
        fieldName="end"
        mask="11:11"
        placeholder={moment().add(2, 'hour').startOf('hour').format('HH:mm')}
        title="End of run-window"
      />
    </ParamsGrid>
  )
}

export default RandomTrigger
